/**
 * True when there is traffic and not one row of it carries a country.
 *
 * Its own module so the test can import it without pulling the dashboard — and with it
 * `i18n.tsx`, which reads `navigator` at module scope and has no business being loaded in
 * a node test.
 *
 * The length check is the point: `[].every()` is true, and a site with no traffic at all
 * has a fact about itself to report ("keine Daten im Zeitraum"), not one about the
 * deployment. '-' and '–' are tolerated because `countryLabel` treats them as unknown too.
 */
export const geoBlind = (rows: { key: string }[]): boolean =>
  rows.length > 0 && rows.every((r) => !r.key || r.key === '-' || r.key === '–');
